<!-- ? V2 1XP -->
<script lang="ts">
import type { ValueOf } from '../../types/helper';
import { LinkVariant } from '../../types/link';
import Icon from '../Icon/Icon.vue';

const sizes = {
  xs: 'xs',
  s: 's',
  m: 'm',
  l: 'l',
} as const;
type IconSize = 'small' | 'medium' | 'large' | 'xLarge';

type Props = {
  ariaLabel?: string;
  buttonType?: 'button' | 'submit';
  endIcon?: string;
  endIconSize?: IconSize;
  isDisabled?: boolean;
  size?: ValueOf<typeof sizes>;
  startIcon?: string;
  startIconSize?: IconSize;
  target?: string;
  text?: string;
  url?: string;
  variant?: ValueOf<typeof LinkVariant>;
  noFollow?: boolean;
};
</script>

<script setup lang="ts">
const props = withDefaults(defineProps<Props>(), {
  size: 'xs',
  variant: 'primary',
  buttonType: 'button',
});

const emit = defineEmits(['click']);

const isLink = Boolean(props.url);

let iconSize: IconSize;

if (props.size === sizes.xs || props.size === sizes.s) {
  iconSize = 'medium';
} else if (props.size === sizes.m) {
  iconSize = 'large';
} else if (props.size === sizes.l) {
  iconSize = 'xLarge';
}

const componentStyle = props.variant.includes('link') ? 'link' : 'btn';
</script>

<template>
  <component
    :is="isLink ? 'a' : 'button'"
    :aria-label="ariaLabel"
    :class="[
      $style.container,
      $style[componentStyle],
      $style[`${componentStyle}__type--${variant}`],
      $style[`${componentStyle}__size--${size}`],
      $style[`${componentStyle}__size--${size}-${text ? 'text' : 'circle'}`],
    ]"
    :disabled="isDisabled ? true : undefined"
    :href="isLink ? url : undefined"
    :rel="noFollow ? 'nofollow' : undefined"
    :target="target === 'blank' || target === '_blank' ? '_blank' : '_self'"
    :type="isLink ? undefined : buttonType"
    @click="!isDisabled ? emit('click', $event) : undefined"
  >
    <Icon v-if="startIcon" :name="startIcon" :size="startIconSize ? startIconSize : iconSize" />
    <span v-if="text" :class="$style.textButton" v-html="text" />
    <Icon v-if="endIcon" :name="endIcon" :size="endIconSize ? endIconSize : iconSize" />
  </component>
</template>

<style module lang="scss" src="./Button1XP.scss" />
